export default __webpack_public_path__ + "static/media/MarketAreaMap.82b9a417.jpg";